module.exports = __webpack_public_path__ + "images/wevide0c692acb8b02e1713bbd6b5702888a.png";